import ImgStaticCard from "@/shared/components/common/imgStaticCard/imgStaticCard";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useEffect, useState } from "react";
import InformationReview from "./informationReview";
import TabInformationReview from "./tabInformationReview";
import { Grid } from "@mui/material";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
/**
 * ContentInformation
 *
 * کامپوننتی برای نمایش وضعیت اعتبار کاربر و ارائه فرم‌های اطلاعات فردی و شغلی.
 * شامل دو حالت اصلی است:
 * 1. نمایش نتیجه بررسی اعتبار (موفق یا ناموفق) با کامپوننت InformationReview.
 * 2. نمایش فرم تکمیل مدارک و اطلاعات شخصی و شغلی با کامپوننت TabInformationReview در صورت شروع فرآیند بارگذاری.
 *
 * @param {Object} props
 * @param {any} props.userInquiry اطلاعات کاربر شامل وضعیت اعتبار و جزئیات شخصی
 * @param {any} props.walletBalance اطلاعات موجودی نقدی و اعتباری کاربر
 *
 * @component
 * @returns JSX.Element
 */

const ContentInformation = ({userInquiry,walletBalance,}: {userInquiry: any;walletBalance: any;}) => {
  const [startUpload, setStartUpload] = useState<boolean>(false);
  const isShowSuccess = userInquiry?.status_manager_answer === "await_document" ? true : false;
  const [selected, setSelected] = useState("all");

  const dataOptionSelect = [
    {
      label: `موجودی نقدی : ${numberSeparator(walletBalance?.balance) ?? 0}`,
      value: "all",
    },
    {
      label: `موجودی اعتباری  : ${
        numberSeparator(walletBalance?.credit?.amount) ?? 0
      }`,
      value: "cash_20card",
    },
  ];

  useEffect(()=>{},[startUpload])

  return (
    <Grid container sx={{width: "100%",justifyContent: "space-between",minHeight: "486px",marginBottom: "30px",padding: "10px 30px",alignItems: "center",display: "flex",}}>
      <Grid size={9}>
        {!startUpload && (
          <StackKit
            sx={{
              width: "100%",
              height: "100%",
              background:"linear-gradient(97.77deg, rgba(0, 0, 0, 0.4) -9.73%, rgba(23, 23, 23, 0.281106) 16.04%, rgba(115, 103, 240, 0.25) 50.23%, rgba(65, 65, 65, 0.231942) 87.66%, rgba(0, 0, 0, 0.16) 109.42%)",
            }}
          >
            {isShowSuccess ? (
              <InformationReview
                setStartUpload={setStartUpload}
                status="موفق"
                contentDetail={
                  <>
                    <TypoGraphyKit>
                      طبق بررسی استعلام های بانکی و قضایی؛ شما مجاز به دریافت
                      اعتبار پولی پی میباشید.
                    </TypoGraphyKit>
                    <StackKit direction={'row'} gap={2}>
                      <TypoGraphyKit className={'me-2'}>پاسخ ادمین:</TypoGraphyKit>
                      <TypoGraphyKit sx={{ color: "#009951FF", }}>{userInquiry.manage_answer}</TypoGraphyKit>
                    </StackKit>
                    <TypoGraphyKit>
                      لطفا در ادامه ؛ مدارک و اطلاعات شخصی و شغلی درخواستی را
                      وارد نمایید.
                    </TypoGraphyKit>
                  </>
                }
              />
            ) : (
              <InformationReview
                status="ناموفق"
                contentDetail={
                  <>
                    <TypoGraphyKit>
                      طبق بررسی ادمین پولی پی؛ شما مجاز به دریافت اعتبار
                      نیستید.{" "}
                    </TypoGraphyKit>
                    <TypoGraphyKit>
                      شما میتوانید با معرفی فرد دیگری به عنوان ضامن، مجددا
                      فرآیند اعتبار سنجی را انجام دهید.{" "}
                    </TypoGraphyKit>
                    <TypoGraphyKit sx={{ color: "#C00F0C" }}>
                      علت عدم تخصیص اعتبار: فرد اعتبار سنجی شده, دارای چک برگشتی
                      میباشد.
                    </TypoGraphyKit>
                  </>
                }
              />
            )}
          </StackKit>
        )}

        {startUpload && (
          <StackKit>
            <TabInformationReview userInquiry={userInquiry} />
          </StackKit>
        )}
      </Grid>
      <Grid size={2}>
        <StackKit direction="column" alignItems="center" justifyContent="center" height="300px">
          <ImgStaticCard imgSlider1="/card-out-simple-flat2-pullipay.svg" imgSlider2="/slide2-pullipay.svg" widthBox="80%"/>
          <BoxKit sx={{ minWidth: "250px", mt: 2 }}>
            <CustomSelectNormal label="" value={selected} onChange={(e) => setSelected(e.target.value)} options={dataOptionSelect} getOptionLabel={(item) => item.label} getOptionValue={(item) => item.value} width="100%"/>
          </BoxKit>
        </StackKit>
      </Grid>
    </Grid>
  );
};

export default ContentInformation;
